<div class="_communication-template-desktop-page">

    @if(type === 'standard') {
        <page-header-component
            title="{{template?.channel}} {{'SENT' | translate}} {{('COMMUNICATION_MESSAGE_TYPE.' + template?.messageType) | uppercase | translate | lowercase}}">
        </page-header-component>
    }

    @if(type === 'custom') {
        @if (action === Action.CREATE) {
            <page-header-component title="{{'COMMUNICATION_TEMPLATE.CREATE' | translate}}"></page-header-component>
        }
        @if (action === Action.UPDATE) {
            <page-header-component title="{{'COMMUNICATION_TEMPLATE.UPDATE' | translate}}: {{template?.customName}}"></page-header-component>
        }
    }

    <div class="_container">

        @if(type === 'standard') {
            <div class="_communication-template-container">

                @if (template.channel === 'sms') {
                    <!-- <div class="_communication-template-disclaimer">
                        <p [translate]="'COMMUNICATION_TEMPLATE.SMS_DISCLAIMER'"></p>
                    </div> -->
                }

                <div class="_editor-container">
                    <editor-component [template]="template.html" [variables]="variables" [type]="template.channel"></editor-component>
                </div>
            </div>
            <div class="_buttons">
                <button type="button" class="_button _edit-button" (click)="openHtmlExample()">
                    <span>{{ 'COMMUNICATION_TEMPLATE.GET_EXAMPLE' | translate}}</span>
                </button>
                <button type="button" class="_button _save-button" (click)="updateStandardTemplate()">
                    <span>{{ 'COMMUNICATION_TEMPLATE.UPDATE' | translate}}</span>
                </button>
            </div>
        }

        @if (type === 'custom') {

            @if (templateForm) {

                <div class="_grouping-disclaimer">
                    <p innerHTML="{{ 'COMMUNICATION_TEMPLATE.CUSTOM_GROUP_TIP' | translate }}"></p>
                </div>

                <div class="_custom-communication-template-inputs-container">
                    <form-input label="{{ 'COMMUNICATION_TEMPLATE.CUSTOM_NAME' | translate }}" [formControl]="templateForm.get('customName') | cast"></form-input>

                    <form-select 
                        label="{{ 'COMMUNICATION_TEMPLATE.CHANNEL' | translate }}" [formControl]="templateForm.get('channel') | cast" [items]="communicationChannels" bindValue="value" bindLabel="label" [multiple]="false">
                    </form-select>
    
                    <form-select 
                        label="{{ 'COMMUNICATION_TEMPLATE.ENDPOINT' | translate }}" [formControl]="templateForm.get('endpoint') | cast" [items]="communicationEndpoints" bindValue="value" bindLabel="label" [multiple]="false">
                    </form-select>
                </div>

            }

            @if ((templateForm?.get('channel').value && templateForm?.get('endpoint').value) || action === Action.UPDATE) {

                <div class="_communication-template-container">

                    @if (templateForm?.get('channel').value === 'sms') {
                        <!-- <div class="_communication-template-disclaimer">
                            <p [translate]="'COMMUNICATION_TEMPLATE.SMS_DISCLAIMER'"></p>
                        </div> -->
                    }

                    <div class="_editor-container">
                        <editor-component [template]="template.html" [variables]="variables" [type]="templateForm.get('channel').value"></editor-component>
                    </div>
                    
                </div>
    
                <div class="_buttons">
                    <button type="button" class="_button _edit-button" (click)="openHtmlExample()">
                        <span>{{ 'COMMUNICATION_TEMPLATE.GET_EXAMPLE' | translate}}</span>
                    </button>

                    @if (action === Action.CREATE) {
                        <button type="button" class="_button _save-button" (click)="createCustomTemplate()">
                            <span>{{ 'COMMUNICATION_TEMPLATE.CREATE' | translate}}</span>
                        </button>
                    }

                    @if (action === Action.UPDATE) {
                        <button type="button" class="_button _delete-button" (click)="deleteCustomTemplate()">
                            <span>{{ 'COMMUNICATION_TEMPLATE.DELETE' | translate}}</span>
                        </button>
                        <button type="button" class="_button _save-button" (click)="updateCustomTemplate()">
                            <span>{{ 'COMMUNICATION_TEMPLATE.UPDATE' | translate}}</span>
                        </button>
                    }

                </div>

            }
            
        }

    </div>
</div>